import styled from 'styled-components';

export const MobileHistoryInfoAmountStyled = styled.div`
    margin-top: 12px;
    
    &.negative {
        color: var(--color-white);
    }
    &.positive {
        color: var(--color-positive);
    }
    &.secondary {
        color: var(--color-white-60);
    }
`;

export const MobileHistoryInfoDividerStyled = styled.div`
    background: var(--color-base-secondary);
    height: 1px;
    width: 100%;
    margin: 24px 0;
`;
